module.exports = __webpack_public_path__ + "media/images/screen-shot-2021-02-11-at-4-02-1-1@2x-819a8f4dda2c57841cf00cfac92f03db.png";